import React from 'react';
import { getAllergenIconSrc, isAllergenIconImage } from '../../utils/publicAllergens';

type AllergenLike = {
  code?: string;
  icon?: string;
  name?: string;
};

type Props = {
  allergen?: AllergenLike | null;
  className?: string;
  invert?: boolean;
  alt?: string;
};

const AllergenIcon: React.FC<Props> = ({
  allergen,
  className = 'w-5 h-5',
  invert = false,
  alt = '',
}) => {
  const src = getAllergenIconSrc(allergen);
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={`${className} flex-shrink-0 object-contain ${invert ? 'brightness-0 invert' : ''}`}
      />
    );
  }
  if (allergen?.icon && !isAllergenIconImage(allergen.icon)) {
    return <span className="text-lg leading-none flex-shrink-0">{allergen.icon}</span>;
  }
  return null;
};

export default AllergenIcon;
